import { PageViewEventProps, reportPageView } from './base';

export const reportPageViewResellingPlans = (data: Omit<PageViewEventProps, 'eventName' | 'pageName'>) => {
    reportPageView({
        eventName: 'reselling_plans_page.show',
        pageName: 'reselling_plans_page',
        ...data,
    });
};

export const reportPageViewResellingPlansSubscriptionDrawer = (
    data: Omit<PageViewEventProps, 'eventName' | 'pageName'>
) => {
    reportPageView({
        eventName: 'reselling_plans_subscription_drawer.show',
        pageName: 'reselling_plans_subscription_drawer',
        ...data,
    });
};
